export interface SavingsMonth {
  month: string;
  savings: number;
}

/** The twelve calendar months ending with the current month, including empty months. */
export function trailingSavingsMonths(months: readonly SavingsMonth[], today = new Date()): SavingsMonth[] {
  const totals = new Map<string, number>();
  for (const entry of months) totals.set(entry.month, (totals.get(entry.month) ?? 0) + entry.savings);
  const year = today.getFullYear();
  const month = today.getMonth();
  return Array.from({ length: 12 }, (_, index) => {
    const date = new Date(Date.UTC(year, month - 11 + index, 1));
    const key = `${String(date.getUTCFullYear())}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
    return { month: key, savings: totals.get(key) ?? 0 };
  });
}
